import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 0,
  class: "m-connection-wrong-network"
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Disconnect ")
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    id: "m-connection",
    class: _normalizeClass(["manifold", {connected: _ctx.walletConnected}])
  }, [
    _createElementVNode("template", null, [
      (_ctx.badConfiguration)
        ? (_openBlock(), _createElementBlock("button", _hoisted_1, _toDisplayString(_ctx.badConfiguration), 1))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_ctx.walletConnected)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  (_ctx.wrongChain)
                    ? (_openBlock(), _createElementBlock("button", _hoisted_3, " Wrong Network "))
                    : (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        class: "m-connection-disconnect-wallet",
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.disconnectAndClose && _ctx.disconnectAndClose(...args)))
                      }, [
                        _hoisted_4,
                        _createElementVNode("span", {
                          class: "m-connection-wallet",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showConnectOptions = !_ctx.showConnectOptions))
                        }, _toDisplayString(_ctx.walletENS ? _ctx.walletENS : _ctx.walletAddressShort), 1)
                      ]))
                ]))
              : (!_ctx.wrongChain && !_ctx.showConnectOptions)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    disabled: _ctx.isLoading,
                    class: "m-connection-connect-wallet",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.setShowConnectOptions && _ctx.setShowConnectOptions(...args)))
                  }, [
                    _createElementVNode("span", { innerHTML: _ctx.buttonText }, null, 8, _hoisted_6)
                  ], 8, _hoisted_5))
                : (!_ctx.showConnectOptions)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 2,
                      disabled: _ctx.isLoading,
                      class: "m-connection-wrong-network"
                    }, " Wrong Network ", 8, _hoisted_7))
                  : _createCommentVNode("", true)
          ], 64))
    ]),
    (_ctx.showConnectOptions && !_ctx.walletConnected)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "m-connection-wallet-options",
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.closeConnectOptions && _ctx.closeConnectOptions(...args)))
        }, [
          (_ctx.walletAvailable)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "m-connection-wallet-option",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.connectWallet && _ctx.connectWallet(...args)))
              }, _toDisplayString(_ctx.browserWalletName), 1))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            class: "m-connection-wallet-option walletconnect",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.connectWalletConnect && _ctx.connectWalletConnect(...args)))
          }, " Wallet Connect ")
        ]))
      : _createCommentVNode("", true)
  ], 2))
}